// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7293cc9b","455":"b82498b2","977":"01172a94"}[chunkId] + ".chunk.js";
};